import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import type { IncidentStatusClient } from '../../../../../core/tokens/incident-status-client.token';
import type {
  IncidentStatusLogDto,
  UpdateIncidentStatusResponse,
} from '../models/incident-status-log.model';

@Injectable({ providedIn: 'root' })
export class IncidentStatusMockService implements IncidentStatusClient {
  patchIncidentStatus(
    incidentId: number,
    _organizationId: number,
    statusId: number,
  ): Observable<UpdateIncidentStatusResponse> {
    return of({ id: incidentId, status: String(statusId) });
  }

  getStatusLogs(_incidentId: number, _organizationId: number): Observable<readonly IncidentStatusLogDto[]> {
    return of([]);
  }
}
